import { Col, Row, Typography } from "antd";
import React from "react";
import useUsers from "../../../../hooks/useUsers";
import color from "../../../../theme/color";
import { SolidPerson } from "../../Icon";
import { IconForm } from "../../Icon/index.styled";

const UserInfo: React.FC = () => {
  const { getAid } = useUsers();

  return (
    <Row
      gutter={6}
      align="middle"
      style={{ position: "relative" }}
      wrap={false}
    >
      <Col style={{ display: "flex" }}>
        <IconForm
          component={SolidPerson}
          style={{
            fontSize: 24,
            background: color.gray8,
            borderRadius: 100,
            overflow: "hidden",
            width: 32,
            height: 32,
            paddingTop: 8,
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          color={color.gray6}
        />
      </Col>
      <Col>
        <Typography.Text
          style={{ fontWeight: 700, whiteSpace: "nowrap" }}
        >{`${getAid()} 님`}</Typography.Text>
      </Col>
    </Row>
  );
};

export default UserInfo;
